<template>
  <modal
    :show.sync="isActiveLocal"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-medi-popup cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
  >
    <div class="flex justify-between pt-4 lg:px-2 md:px-2 px-2 pb-8">
      <div class="my-auto">
        <p class="text-2xl col-black font-bold">Post a Requirement</p>
      </div>
      <img
        src="../../../assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLocal = false"
      />
    </div>
    <div class="lg:px-2 md:px-2 px-2">
      <div>
        <div v-if="!isshowform">
          <div class="mt-4">
            <p class="col-black font-semibold">First Name</p>
            <b-input
              placeholder="First Name"
              class="form-control-muted mb-4"
              v-model="user.firstname"
              :disabled="true"
            />
            <p class="col-black font-semibold">Last Name</p>
            <b-input
              placeholder="Last Name"
              class="form-control-muted mb-4"
              v-model="user.lastname"
              :disabled="true"
            />
            <div class="">
              <p class="col-black font-semibold">Service Type</p>
              <!-- <b-input
            placeholder="Enter Service Type"
            class="form-control-muted mb-4"
            v-model="servicetype"
          /> -->
              <div>
                <b-form-select
                  v-model="selectServiceType"
                  :options="optionService"
                  class="my-3"
                ></b-form-select>
              </div>
            </div>
            <p class="col-black font-semibold">Service Required</p>
            <b-input
              placeholder="Service Required"
              class="form-control-muted mb-4"
              v-model="servicereq"
            />

            <div class="flex gap-4">
              <div class="w-1/2">
                <p class="col-black font-semibold">Start Date</p>
                <base-input
                  type="date"
                  value="Description"
                  id="example-date-input"
                  class="form-control-muted mb-4"
                  placeholder="Enter Date"
                  v-model="date"
                />
              </div>
              <div class="w-1/2">
                <b-form-group label="Time" class="col-black pb font-semibold">
                  <date-picker
                    v-model="selecttime"
                    format="HH:mm"
                    value-type="format"
                    type="time"
                    class="w-full mb-4"
                    :config="configdateTimePicker"
                    placeholder="hh:mm"
                  >
                  </date-picker>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div v-show="isshowform">
          <!-- <feather-icon
            icon="ChevronLeftIcon"
            class="cursor-pointer"
            @click="isshowform = false"
          /> -->
          <div v-show="selectServiceType === 'inperson'">
            <div class="">
              <p class="col-black font-semibold">Address</p>
              <textarea
                class="form-control mb-4"
                placeholder="Enter Address"
                id="exampleFormControlTextarea3"
                rows="3"
                v-model="address"
              ></textarea>
            </div>
            <div class="flex gap-4">
              <div class="w-1/2">
                <p class="col-black font-semibold">City</p>
                <b-input
                  placeholder="Enter City Name"
                  class="form-control-muted mb-4"
                  v-model="city"
                />
              </div>

              <div class="w-1/2">
                <p class="col-black font-semibold">
                  Pincode

                  <b-input
                    type="number"
                    placeholder="Enter Pincode"
                    class="form-control-muted mb-4"
                    v-model="pincode"
                    @change="validatePincode"
                  />
                  <!-- <span class="clr-red">*</span> -->
                </p>
              </div>
            </div>

            <div class="">
              <p class="col-black font-semibold">State</p>
              <div>
                <b-form-select
                  v-model="selectstate"
                  :options="optionState"
                  class="mb-4"
                ></b-form-select>
              </div>
            </div>
          </div>
          <p class="col-black font-semibold">Description</p>
          <textarea
            class="form-control mb-4"
            placeholder="Enter Description"
            id="exampleFormControlTextarea3"
            rows="3"
            v-model="description"
          ></textarea>
        </div>
        <div class="text-center flex item-center justify-center">
          <b-button
            variant="primary"
            class="mr-4 mt-4"
            @click="isshowform = true"
            :disabled="
              selectServiceType === null ||
              selecttime === null ||
              date === '' ||
              servicereq === ''
            "
            v-if="!isshowform"
            >Next</b-button
          >
          <b-button
            variant="primary"
            class="mr-4 mt-4"
            v-if="isshowform"
            @click="isshowform = false"
            >Previous</b-button
          >
          <b-button
            variant="primary"
            class="mr-4 mt-4"
            v-if="isshowform"
            :disabled="
              selectServiceType === 'inperson'
                ? selectstate === null ||
                  city === '' ||
                  pincodeDisable ||
                  address === '' ||
                  description === ''
                : description === ''
            "
            @click="handleSumbit"
            >Submit</b-button
          >
        </div>
      </div>
    </div>
    <template slot="footer" class="hidden"> <div></div> </template>
  </modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapState } from "vuex";
import { State } from "country-state-city";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      isshowform: false,
      value: "",
      description: "",
      selecttime: null,
      date: "",
      address: "",
      city: "",
      state: [],
      pincode: null,
      selectstate: null,
      selectServiceType: null,
      servicereq: "",
      status: "",
      configdateTimePicker: "",
      selected: null,
      optionService: [
        { value: null, text: "Please select an option" },
        // { value: "online", text: "Online" },
        { value: "inperson", text: "In-person" },
      ],
      optionState: [{ value: null, text: "Please select an option" }],
      pincodeDisable: true,
      code: 0,
    };
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedpostrequirement: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapState("auth", { user: "user" }),
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  watch: {
    pincode(newVal, oldVal) {
      // console.log(oldVal, "   ", newVal);

      if (newVal) {
        if (this.pincode.length == 6) {
          this.code = this.pincode;
        }
        if (this.pincode.length < 6) {
          this.pincodeDisable = false;
        } else if (this.pincode.length > 6) {
          this.pincode = this.code;
          this.pincodeDisable = true;
        }
      }
    },
  },
  methods: {
    validatePincode() {
      // console.log(this.pincode.length);
    },
    async handleSumbit() {
      let payload = {
        serviceReq: this.servicereq,
        serviceType: this.selectServiceType,
        firstName: this.user.firstname,
        lastName: this.user.lastname,
        date: this.date,
        time: this.selecttime,
        description: this.description,
        status: this.status,
        address: this.address,
        city: this.city,
        pincode: isNaN(this.pincode) ? null : parseInt(this.pincode),
        state: this.selectstate,
      };

      try {
        const data = await this.$store.dispatch(
          "respitecare/createrequirement",
          payload
        );

        const emailPayload = {
          userEmail: this.user.email,
        };

        const postreqEmail = await this.$store.dispatch(
          "respitecare/email_postreq",
          emailPayload
        );
        this.closeModal();
        this.$swal.fire({
          text: "Requirement Added Successfully",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        payload = {};
        this.serviceReq = "";
        this.selectServiceType = null;
        this.selectstate = null;
        this.date = "";
        this.selecttime = null;
        this.description = "";
        this.status = "";
        this.address = "";
        this.city = "";
        this.pincode = null;
      } catch (error) {
        payload = {};
      }
    },

    closeModal() {
      this.$emit("close");
    },
  },
  async mounted() {
    this.state = await State.getStatesOfCountry("IN").map((state) => {
      return { value: state.name, text: state.name };
    });
    this.optionState = [...this.optionState, ...this.state];
  },
};
</script>
<style>
.mx-datepicker {
  width: 100%;
}
.mx-input {
  height: 42px !important;
}
.col-form-label {
  padding-bottom: 3px !important;
}
</style>
